// extracted by mini-css-extract-plugin
export var divider = "_wi-0";